export default __webpack_public_path__ + "static/media/blog-img225.0735ef56.jpg";